module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-lo"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "lo-modal-title"
  }, [_vm._v("XEM GIẢI THÍCH CHI TIẾT TỪNG CÂU HỎI")]), _c('span', {
    staticClass: "lo-modal-btn-close material-icons",
    on: {
      "click": _vm.closePopupFree
    }
  }, [_vm._v("close")])]), _vm._m(0), _c('div', {
    staticClass: "modal-footer lo-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-12 text-center"
  }, [_c('a', {
    staticClass: "lo-btn-continue lo-popup-pc btn",
    on: {
      "click": function($event) {
        return _vm.continuteConfirmFinish()
      }
    }
  }, [_vm._v("Xác nhận")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "reg-content"
  }, [_vm._v("Bài tập này không tốn phí để xem giải thích chi tiết từng câu hỏi.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae55cb44","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/Exercise/popupFree.vue
// module id = 1641
// module chunks = 0